var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3675 2.26453H2.19278C1.87643 2.26453 1.57305 2.39019 1.34936 2.61388C1.12567 2.83757 1 3.14096 1 3.4573V11.8068C1 12.1231 1.12567 12.4265 1.34936 12.6502C1.57305 12.8739 1.87643 12.9995 2.19278 12.9995H10.5422C10.8586 12.9995 11.162 12.8739 11.3856 12.6502C11.6093 12.4265 11.735 12.1231 11.735 11.8068V7.63203",
    stroke: "#0D85FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8407 1.37055C11.078 1.13329 11.3997 1 11.7353 1C12.0708 1 12.3926 1.13329 12.6299 1.37055C12.8671 1.60781 13.0004 1.9296 13.0004 2.26513C13.0004 2.60067 12.8671 2.92246 12.6299 3.15972L6.96417 8.82541L4.57861 9.4218L5.175 7.03625L10.8407 1.37055Z",
    stroke: "#0D85FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9cadf82b7d56dd35978c6b9d72974ebe.svg";
export { ForwardRef as ReactComponent };